import "./App.css";
import Box from "./Box";

function App() {
  return (
    <div className="App">
      <div className="box_wrapper">
        <Box />
      </div>
    </div>
  );
}

export default App;
